import { BasePageComponent } from '@/components/base/BasePageComponent';
import { ConfirmDialogComponent } from '@/components/confirm-dialog/confirm-dialog.component';
import { UserHelper } from '@/helpers/user.helper';
import { Paging } from '@/models/Paging';
import { AlertService } from '@/services/alert.service';
import { NavService } from '@/services/nav.service';
import { NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { UserSummary, UserSummaryDetail, UsersService } from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { PageTitleComponent } from '../../components/page-title/page-title.component';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss'],
  standalone: true,
  imports: [
    PageTitleComponent,
    NgIf,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    MatPaginatorModule
  ]
})
export class ContactsComponent extends BasePageComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  dataSource: MatTableDataSource<UserSummary>;
  displayedColumns = ['name', 'email', 'phoneNumber', 'type', 'actions'];

  paging = new Paging();

  contactSub = new Subscription();
  deleteSub = new Subscription();

  constructor(
    private usersService: UsersService,
    protected route: ActivatedRoute,
    protected navService: NavService,
    private userHelper: UserHelper,
    private dialog: MatDialog,
    private alertService: AlertService
  ) {
    super(route, navService);
  }

  ngOnInit(): void {
    this.loadData();
  }

  ngOnDestroy(): void {
    this.contactSub.unsubscribe();
    this.deleteSub.unsubscribe();
  }

  loadData() {
    let filter: string;
    if (this.dataSource && this.dataSource.filter) {
      filter = this.dataSource.filter;
    }
    const displayedData = [];
    this.contactSub = this.usersService
      .searchUserContacts(this.userHelper.currentUser.userId, null, null)
      .subscribe((data) => {
        data.forEach((i) => {
          const row = {
            user: i,
            name: UserHelper.userSummmaryDisplayName(i as UserSummary),
            email: i.email,
            phoneNumber: i.phoneNumber,
            type: this.userHelper.getRoleName(i.role)
          };
          displayedData.push(row);
        });
      });
    this.dataSource = new MatTableDataSource(displayedData);
    // *ngIf break the paginator and sort : must be set in background
    setTimeout(() => {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });

    if (filter) {
      this.applyFilter(filter);
    }
  }

  ngAfterViewInit() {
    // If the user changes the sort order, reset back to the first page.
    if (this.sort) {
      this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
    }
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  confirmDelete(user: UserSummaryDetail) {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        // width: '25rem',
        data: {
          message:
            'Confirmez-vous la suppression du contact "' +
            UserHelper.userSummmaryDisplayName(user as UserSummary) +
            '" ?'
        }
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.doDelete(user);
        }
      });
    }
  }

  doDelete(user: UserSummaryDetail) {
    this.deleteSub = this.usersService
      .deleteUserContact(this.userHelper.currentUser.userId, user.uid)
      .subscribe((result) => {
        this.alertService.success('Suppression effectuée avec succès');
        this.loadData();
      });
  }
}
